// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer_logo[data-v-ba436884]{display:flex;align-items:center;justify-content:center;width:140px;height:30.5px;font-size:0;flex-shrink:0}.customer_logo img[data-v-ba436884]{-o-object-fit:contain;object-fit:contain;width:140px!important;height:30.5px!important}", ""]);
// Exports
module.exports = exports;
